import React, { useRef, useState, useEffect } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import { InputSearch } from './Inputs'
import { useWindowSize } from '../util/Utilitarios'
import { Link } from 'react-router-dom'
import { BotaoPadrao, BotaoMenu } from './Botoes'
import { get } from '../util/AcessoApi'
import { getUsuario } from '../util/Configuracoes'

const HeaderCadastro = (props) => {
    return (<div className="row">
        <div className="col-12">
            <div className="mb-2 row-space-between">
                <div className={`display-flex ${props.classeChildren || ''}`}>
                    <div>
                        <h3><span>{props.titulo}</span></h3>
                        {!props.subtitulo && <label>&nbsp;</label> || <label>{props.subtitulo}</label>}
                        {props.pesquisa && <InputSearch value={props.valorPesquisa} onChange={(value) => props.onChangePesquisa(value.target.value)} />}
                    </div>
                    <div className='lh-2 ml-3'>
                        {props.children}
                    </div>
                </div>
                {props.link && <nav className="pt-0 breadcrumb-container d-none d-sm-block d-lg-inline-block" aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        {props.link.map((Link, index) => {
                            return <li key={index} className="breadcrumb-item titulo-link"><a aria-current="page" className="active" href="/"><span><Link /></span></a></li>
                        })}
                    </ol>
                </nav>}
            </div>
            <div className="separator mb-3"></div>
        </div>
    </div>)
}

const HeaderH5Cadastro = (props) => {
    return (<div className="row">
        <div className="col-12">
            <div className="mb-2 row-space-between">
                <div className={`display-flex ${props.classeChildren || ''}`}>
                    <div>
                        <h5><span>{props.titulo}</span></h5>
                        {props.subtitulo && <label>{props.subtitulo}</label>}
                        {props.pesquisa && <InputSearch value={props.valorPesquisa} onChange={(value) => props.onChangePesquisa(value.target.value)} />}
                    </div>
                    <div className='lh-2 ml-3'>
                        {props.children}
                    </div>
                </div>
                {props.link && <nav className="pt-0 breadcrumb-container d-none d-sm-block d-lg-inline-block" aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        {props.link.map((Link, index) => {
                            return <li key={index} className="breadcrumb-item titulo-link"><a aria-current="page" className="active" href="/"><span><Link /></span></a></li>
                        })}
                    </ol>
                </nav>}
            </div>
            <div className="separator mb-3"></div>
        </div>
    </div>)
}

const HeaderConsulta = (props) => {
    const size = useWindowSize();
    return (<div className="row">
        <div className="col-12">
            <div className={`mb-2 ${size[0] > 780 && 'row-space-between' || ''}`}>
                <div className={`display-flex ${props.classeChildren || ''}`}>
                    <h3 className={`${size[0] <= 781 ? 'titulo-header-responsivo' : 'mb-2'}`}>
                        <span className={`${props.icone} mr-3`}></span>
                        <span>{props.titulo}</span>
                    </h3>
                    {props.pesquisa && <InputSearch value={props.valorPesquisa} onChange={(value) => props.onChangePesquisa(value.target.value)} />}
                    <div className='lh-2 ml-3'>
                        {props.children}
                    </div>
                </div>
                {props.link && <nav className="pt-0 breadcrumb-container d-none d-sm-block d-lg-inline-block" aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        {props.link.map((Link, index) => {
                            return <li key={index} className="breadcrumb-item titulo-link"><a aria-current="page" className="active" href="/"><span><Link /></span></a></li>
                        })}
                    </ol>
                </nav>}
                <div className={`header-botoes  ${size[0] < 781 && 'text-right' || ''}`}>
                    {
                        props.actionImportacao &&
                        <BotaoPadrao texto="Importar" classe={`${size[0] <= 781 ? 'btn-responsive width-100 btn btn-primary primary' : ''}`}
                            click={_ => props.actionImportacao()} /> || ''
                    }
                    {
                        props.urlCadastro &&
                        <Link to={props.urlCadastro}>
                            <BotaoPadrao texto="Cadastrar" classe={`${size[0] <= 781 ? 'btn-responsive width-100 btn btn-primary primary' : ''}`} />
                        </Link>
                    }
                    {
                        props.botoesHeader &&
                        props.botoesHeader.map(x =>
                            <Link to={x.url}>
                                <BotaoPadrao texto={x.titulo} classe={`${size[0] <= 781 ? 'btn-responsive width-100 btn btn-primary primary mb-2' : ''}`} icone={x.icone} />
                            </Link>
                        )
                    }
                </div>
            </div>
            <div className="separator mb-3"></div>
        </div>
    </div>)
}

export { HeaderCadastro, HeaderConsulta, HeaderH5Cadastro }
